module.exports = __webpack_public_path__ + "static/media/file.014e4874.svg";